var _path, _circle, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _circle2, _circle3, _circle4, _circle5, _circle6, _path9, _path10, _path11, _circle7, _ellipse2, _path12, _path13, _path14, _ellipse3, _ellipse4, _ellipse5, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullsEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 213,
    viewBox: "0 0 287 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.341 22.4734L211.396 9.20757C209.419 7.65983 208.82 5.02797 210.088 3.10173C211.382 1.13766 214.15 0.614751 216.422 1.84458L216.88 1.17327C217.513 0.244934 219.118 1.10815 218.698 2.15146L218.383 2.93414C220.51 4.23664 221.463 6.77656 220.515 8.86038C219.618 10.833 217.315 11.7421 215.08 11.1401L209.031 26.1712L209.971 26.6913C209.971 26.6913 209.066 32.1298 208.659 33.2271C208.654 33.2394 208.648 33.2509 208.64 33.2617C208.621 33.3238 208.6 33.3854 208.577 33.4468C208.32 34.1405 207.875 34.7171 207.297 35.1616L207.199 35.6655C207.183 35.689 207.167 35.7123 207.15 35.7354C207.109 35.8858 207.071 36.0108 207.036 36.1042C207.032 36.1166 207.025 36.1283 207.018 36.1391C206.999 36.2007 206.978 36.2619 206.955 36.3228C206.078 38.6878 203.021 39.6917 199.917 38.7388L197.004 41.7302C196.654 42.0901 196.051 41.7391 196.168 41.2428L197.101 37.2621C195.119 35.6818 194.157 33.3789 194.878 31.4338C194.901 31.3729 194.925 31.3129 194.951 31.2539C194.952 31.2405 194.955 31.2276 194.96 31.2153C195.016 31.0638 195.149 30.8331 195.337 30.5478C195.359 30.3288 195.396 30.1121 195.448 29.8987L196.501 28.5559C196.524 28.4956 196.548 28.4361 196.573 28.3775C196.574 28.3639 196.577 28.3508 196.582 28.3381C196.989 27.2407 201.442 21.9762 201.442 21.9762L202.341 22.4734Z",
    fill: "url(#paint0_linear_1031_20318)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 196.877,
    cy: 41.6077,
    r: 1.5,
    transform: "rotate(-12.8394 196.877 41.6077)",
    fill: "#E2E2E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.712 40.8042L201.716 38.2584L203.512 41.8572L196.931 41.7497C196.41 41.7412 196.248 41.0405 196.712 40.8042Z",
    fill: "#414558"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.868 45.2427C208.802 45.2709 208.735 45.2977 208.668 45.3231C205.832 46.3839 202.51 44.5074 201.247 41.1317C199.984 37.7561 201.259 34.1595 204.094 33.0987C204.163 33.0731 204.231 33.0492 204.3 33.027C204.312 33.0191 204.325 33.0126 204.339 33.0075C205.561 32.5501 213.23 32.1894 213.23 32.1894L215.392 41.6928C215.392 41.6928 210.135 44.7745 208.912 45.2319C208.898 45.2372 208.883 45.2408 208.868 45.2427Z",
    fill: "#B6B9C9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.654,
    cy: 37.047,
    rx: 4.17661,
    ry: 4.95972,
    transform: "rotate(-20.5119 213.654 37.047)",
    fill: "url(#paint1_linear_1031_20318)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.839 40.7611C201.55 37.3171 203.052 33.8328 205.806 32.4579L210.048 32.1165C210.284 32.1904 210.281 32.2665 210.511 32.3699C208.753 33.5385 207.639 36.4317 208.577 38.9403C209.584 41.6297 211.967 42.6679 214.016 42.4854L209.401 45.0482C207.018 45.3825 203.837 43.4306 202.839 40.7611Z",
    fill: "#21263F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.038 30.1216L235.466 33.016C236.265 35.6591 239.056 37.1538 241.699 36.3546C244.342 35.5553 245.837 32.7648 245.038 30.1216Z",
    fill: "#21263F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.948 40.8149C215.869 40.848 215.788 40.8777 215.705 40.9037C213.927 41.459 211.933 40.136 211.249 37.9487C210.566 35.7614 211.453 33.5382 213.23 32.9829C213.313 32.9569 213.397 32.935 213.481 32.9171L213.477 32.9056L245.584 28.3924C246.827 28.2176 247.254 29.9891 246.068 30.3998L215.952 40.8264L215.948 40.8149Z",
    fill: "url(#paint2_linear_1031_20318)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.762 28.9115L234.881 30.4507C234.456 27.7224 236.323 25.1662 239.052 24.7411C241.78 24.3161 244.336 26.1832 244.762 28.9115Z",
    fill: "#21263F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.895 29.8053L235.229 32.3704C235.351 32.8234 237.612 32.6169 240.28 31.9089C242.948 31.2008 245.014 30.2592 244.895 29.8053Z",
    fill: "#21263F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.269,
    cy: 33.3129,
    r: 0.5,
    transform: "rotate(-12.8394 206.269 33.3129)",
    fill: "url(#paint3_linear_1031_20318)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.763,
    cy: 35.7074,
    r: 0.5,
    transform: "rotate(-12.8394 204.763 35.7074)",
    fill: "url(#paint4_linear_1031_20318)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.455,
    cy: 38.8549,
    r: 0.5,
    transform: "rotate(-12.8394 204.455 38.8549)",
    fill: "url(#paint5_linear_1031_20318)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.097,
    cy: 41.5571,
    r: 0.5,
    transform: "rotate(-12.8394 206.097 41.5571)",
    fill: "url(#paint6_linear_1031_20318)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.491,
    cy: 43.0629,
    r: 0.5,
    transform: "rotate(-12.8394 208.491 43.0629)",
    fill: "url(#paint7_linear_1031_20318)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.335 9.991C142.823 10.84 142.994 11.905 143.701 12.465L140.055 18.3253L139.73 18.1563C139.73 18.1563 137.962 20.5168 137.788 20.9876C137.786 20.9927 137.785 20.998 137.784 21.0034C137.774 21.0285 137.764 21.0539 137.754 21.0795L137.334 21.6788C137.31 21.7689 137.292 21.8598 137.279 21.951C137.203 22.0768 137.149 22.1779 137.125 22.2429C137.123 22.2486 137.121 22.2545 137.121 22.2606C137.11 22.286 137.1 22.3116 137.09 22.3376C136.782 23.1722 137.096 24.0861 137.804 24.6595L137.716 25.0097C137.585 25.5222 138.243 25.8458 138.588 25.4386L138.827 25.1559C139.967 25.4236 141.128 24.8835 141.503 23.869C141.513 23.8422 141.522 23.8153 141.531 23.7884C141.533 23.7839 141.536 23.7791 141.538 23.7742C141.552 23.7344 141.569 23.6816 141.587 23.6182C141.594 23.6078 141.601 23.5973 141.607 23.5867L141.653 23.3748C141.878 23.1673 142.056 22.9104 142.166 22.6128C142.176 22.5868 142.185 22.5607 142.193 22.5346C142.196 22.5296 142.199 22.5244 142.201 22.5189C142.375 22.0482 142.821 19.7602 142.821 19.7602L142.48 19.5832L145.039 13.1152C145.861 13.2733 146.739 12.8032 147.114 11.9501C147.509 11.049 147.204 10.0365 146.436 9.58409L146.569 9.24721C146.746 8.79827 146.164 8.50639 145.909 8.91646L145.725 9.21264C144.901 8.79605 143.857 9.1253 143.335 9.991Z",
    fill: "url(#paint8_linear_1031_20318)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.939 23.778C139.316 23.0576 138.2 23.0674 137.589 23.7986L100.443 68.3121C99.4354 69.519 99.5134 71.2984 100.622 72.4117L99.0412 73.999C97.113 72.0631 96.9773 68.969 98.7286 66.8704L135.876 22.3569C137.369 20.5669 140.103 20.543 141.628 22.3066L179.894 66.5718C180.746 67.5571 180.694 69.0358 179.775 69.9582L178.194 68.3709C178.283 68.2817 178.288 68.1386 178.205 68.0433L139.939 23.778Z",
    fill: "url(#paint9_linear_1031_20318)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 23.999L145 19.999L145.5 23.499L137.5 25.999V23.999Z",
    fill: "#21263F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 21.999,
    r: 4,
    fill: "#575C75"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.595,
    cy: 113.5,
    rx: 45.0886,
    ry: 59.8291,
    fill: "url(#paint10_linear_1031_20318)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.56 45.1146C112.24 47.1837 90.5697 77.0098 90.5697 113.5C90.5697 149.99 112.24 179.816 139.56 181.885C138.556 181.961 137.544 182 136.525 182C107.793 182 84.5 151.332 84.5 113.5C84.5 75.6685 107.793 45 136.525 45C137.544 45 138.556 45.0386 139.56 45.1146Z",
    fill: "#21263F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.595 182C171.328 182 194.62 151.332 194.62 113.5C194.62 75.6685 171.328 45 142.595 45C113.862 45 90.5696 75.6685 90.5696 113.5C90.5696 151.332 113.862 182 142.595 182ZM142.595 173.329C167.497 173.329 187.684 146.543 187.684 113.5C187.684 80.4573 167.497 53.6709 142.595 53.6709C117.693 53.6709 97.5063 80.4573 97.5063 113.5C97.5063 146.543 117.693 173.329 142.595 173.329Z",
    fill: "url(#paint11_linear_1031_20318)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.595 53.6709C141.724 53.6709 140.86 53.7036 140.001 53.7682L144.622 113.267L127.491 57.1105C124.697 58.428 122.031 60.1008 119.521 62.0878L144.569 113.845L109.809 72.4287C108.168 74.734 106.664 77.2122 105.314 79.8406L144.425 114.001L100.153 93.2535C99.488 95.7089 98.9402 98.2388 98.519 100.831L144.276 114.169L97.5069 113.214C97.5065 113.309 97.5063 113.405 97.5063 113.5C97.5063 115.92 97.6146 118.305 97.8249 120.65L144.225 114.385L99.8557 132.611C100.509 135.183 101.29 137.677 102.189 140.079L144.251 114.614L107.612 151.249C109.15 153.754 110.837 156.091 112.655 158.236L144.317 114.887L120.815 165.899C123.325 167.739 125.981 169.272 128.754 170.457L144.527 115.002L140.131 173.241C140.947 173.3 141.768 173.329 142.595 173.329C144.888 173.329 147.14 173.102 149.341 172.664L144.709 114.363L144.714 114.344L144.727 114.326L144.746 114.315L144.767 114.312L144.788 114.318L144.805 114.334L145.191 115.13L145 114.503L145.456 114.902L145.024 114.387L145.616 114.56L145.016 114.278L145.622 114.197L144.963 114.183L145.483 113.869L144.881 114.116L144.881 114.115L145.236 113.63L144.851 114.015L144.828 113.942L144.951 113.512L144.798 113.843L144.652 113.363L149.475 54.363C147.232 53.9073 144.934 53.6709 142.595 53.6709ZM160.656 58.6643C163.268 60.1808 165.75 62.0161 168.075 64.1332L144.951 113.512L160.656 58.6643ZM179.733 79.562C178.428 77.052 176.982 74.6808 175.41 72.4685L145.235 113.628L179.733 79.562ZM184.232 90.503C184.944 92.7676 185.553 95.1026 186.053 97.498L145.483 113.868L184.232 90.503ZM187.663 115.317C187.677 114.714 187.683 114.108 187.683 113.5C187.683 111.855 187.633 110.225 187.535 108.613L145.622 114.196L187.663 115.317ZM185.134 133.381L145.617 114.56L186.602 126.585C186.212 128.904 185.721 131.172 185.134 133.381ZM176.713 152.617L145.457 114.9L180.601 145.706C179.429 148.135 178.129 150.444 176.713 152.617ZM161.001 168.133L145.192 115.129L168.155 162.794C165.909 164.848 163.516 166.639 161.001 168.133Z",
    fill: "url(#paint12_linear_1031_20318)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.329,
    cy: 113.5,
    rx: 6.93671,
    ry: 8.67089,
    fill: "#C4C7D4"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.329,
    cy: 113.5,
    rx: 5.20253,
    ry: 6.93671,
    fill: "#21263F"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.329,
    cy: 113.5,
    rx: 2.60127,
    ry: 3.46835,
    fill: "#11E4CB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.427 173.261C164.322 171.76 183.348 145.578 183.348 113.5C183.348 81.4216 164.322 55.2397 140.427 53.7388C141.146 53.6937 141.868 53.6709 142.595 53.6709C167.497 53.6709 187.684 80.4573 187.684 113.5C187.684 146.543 167.497 173.329 142.595 173.329C141.868 173.329 141.146 173.306 140.427 173.261Z",
    fill: "#575C75"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.329 139.513C155.503 139.513 165.139 128.22 165.139 113.5C165.139 98.7798 155.503 87.4874 144.329 87.4874C133.155 87.4874 123.519 98.7798 123.519 113.5C123.519 128.22 133.155 139.513 144.329 139.513ZM144.329 141.247C156.78 141.247 166.873 128.824 166.873 113.5C166.873 98.1759 156.78 85.7532 144.329 85.7532C131.878 85.7532 121.785 98.1759 121.785 113.5C121.785 128.824 131.878 141.247 144.329 141.247Z",
    fill: "url(#paint13_linear_1031_20318)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.177 149.879C173.921 140.634 178.146 127.778 178.146 113.5C178.146 99.2221 173.921 86.366 167.177 77.1215C160.432 67.8756 151.26 62.3418 141.294 62.3418C131.328 62.3418 122.156 67.8756 115.411 77.1215C108.667 86.366 104.443 99.2221 104.443 113.5C104.443 127.778 108.667 140.634 115.411 149.879C122.156 159.125 131.328 164.658 141.294 164.658C151.26 164.658 160.432 159.125 167.177 149.879ZM141.294 166.392C162.604 166.392 179.88 142.712 179.88 113.5C179.88 84.2884 162.604 60.6077 141.294 60.6077C119.984 60.6077 102.709 84.2884 102.709 113.5C102.709 142.712 119.984 166.392 141.294 166.392Z",
    fill: "url(#paint14_linear_1031_20318)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1031_20318",
    x1: 199.07,
    y1: 37.9494,
    x2: 244.676,
    y2: -40.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1031_20318",
    x1: 210.056,
    y1: 34.7647,
    x2: 216.564,
    y2: 35.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1031_20318",
    x1: 228.429,
    y1: 29.291,
    x2: 231.206,
    y2: 41.4785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575C75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1031_20318",
    x1: 206.269,
    y1: 32.8129,
    x2: 206.269,
    y2: 33.8129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B9887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1031_20318",
    x1: 204.763,
    y1: 35.2074,
    x2: 204.763,
    y2: 36.2074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B9887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1031_20318",
    x1: 204.455,
    y1: 38.3549,
    x2: 204.455,
    y2: 39.3549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B9887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1031_20318",
    x1: 206.097,
    y1: 41.0571,
    x2: 206.097,
    y2: 42.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B9887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1031_20318",
    x1: 208.491,
    y1: 42.5629,
    x2: 208.491,
    y2: 43.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B9887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1031_20318",
    x1: 138.992,
    y1: 23.9647,
    x2: 156.745,
    y2: -8.39728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1031_20318",
    x1: 139,
    y1: 20.999,
    x2: 177.32,
    y2: 52.8515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A5BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1031_20318",
    x1: 182.915,
    y1: 100.927,
    x2: 97.5063,
    y2: 113.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8FA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1031_20318",
    x1: 92.3038,
    y1: 119.136,
    x2: 194.62,
    y2: 100.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A5BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1031_20318",
    x1: 103.576,
    y1: 126.073,
    x2: 185.082,
    y2: 104.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1031_20318",
    x1: 168.174,
    y1: 105.696,
    x2: 119.184,
    y2: 123.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8FA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1031_20318",
    x1: 182.915,
    y1: 102.228,
    x2: 98.3734,
    y2: 122.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C7393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8FA8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullsEye);
export default __webpack_public_path__ + "static/media/bulls-eye.f61386122bd8afc5569b6ff5ead19b22.svg";
export { ForwardRef as ReactComponent };